// ─── SUPABASE CONFIG ─────────────────────────────────────────────────────
// TWO WAYS TO CONNECT (either works):
//   A. In the app: Profile tab → Connection — paste keys once; they are
//      saved in this browser's localStorage and SURVIVE zip overwrites.
//      This is the recommended path.
//   B. Here (one time, ~3 minutes):
//   1. Go to https://supabase.com/dashboard → open your project
//      (the same one your expense tracker uses — or a new free project).
//   2. Click Settings (gear icon, bottom left) → API.
//   3. Copy "Project URL" into SUPABASE_URL below.
//   4. Copy the "anon" "public" key into SUPABASE_ANON_KEY below.
//   5. Run supabase-schema.sql once in the SQL Editor (see README).
//
// Until keys exist, the app runs in DEMO MODE: "Still there?"
// confirmations only live on this device for this visit.
// Nothing here is secret — the anon key is meant to be public — but
// never paste your "service_role" key anywhere in this app.

export const SUPABASE_URL = "PASTE_YOUR_SUPABASE_URL_HERE";
export const SUPABASE_ANON_KEY = "PASTE_YOUR_SUPABASE_ANON_KEY_HERE";
